import _regenerator from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _slicedToArray from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _toConsumableArray from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectSpread from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.every.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.reduce.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.link.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { getExtendedStats, getTaskStaticalData } from '@/api/home';
import echarts from '@/components/echarts';
import echartTheme from '@/components/echarts/theme';
import TaskInfo from '@/views/system/index/components/task-info';
import Performance from '@/views/system/index/components/performance';
import Unclaimed from '@/views/system/index/components/unclaimed';
import { mapState } from 'vuex';
export default {
  components: {
    Unclaimed: Unclaimed,
    Performance: Performance,
    TaskInfo: TaskInfo
  },
  computed: _objectSpread(_objectSpread({
    baseList: function baseList() {
      return this.dataList.map(function (item) {
        var key = item.varKey;
        var year;
        var id;
        if (key) {
          var keys = item.varKey.split(',');
          if (keys.length === 2) {
            year = keys[1];
            id = keys[0];
          }
        }
        return _objectSpread(_objectSpread({}, item), {}, {
          _id: id,
          _year: year
        });
      });
    },
    list: function list() {
      var _this = this;
      return this.baseList.filter(function (item) {
        return item._year === "".concat(_this.year.getFullYear());
      });
    },
    tableData: function tableData() {
      var _this2 = this;
      var sum = {
        type: 'sum',
        c06YDraft: 0,
        c06YSend: 0,
        c06YBack: 0,
        c06WDraft: 0,
        c06WSend: 0,
        c06WBack: 0,
        c06QDraft: 0,
        c06QSend: 0,
        c06QBack: 0,
        c06YBConclusion: 0,
        c06YBStatus: 0,
        c06YBAddress: 0,
        c06WBConclusion: 0,
        c06WBStatus: 0,
        c06WBAddress: 0,
        c06QBConclusion: 0,
        c06QBStatus: 0,
        c06QBAddress: 0,
        c06YBack2: 0,
        c06YBEffective: 0,
        c06YBInvalid: 0,
        c06WBack2: 0,
        c06WBEffective: 0,
        c06WBInvalid: 0,
        c06QBack2: 0,
        c06QBEffective: 0,
        c06QBInvalid: 0
      };
      var baseList = JSON.parse(JSON.stringify(this.baseList));
      var filterArr = this.filterArr;
      if (filterArr.length) {
        baseList = baseList.filter(function (item) {
          return _this2.filterArr.every(function (sub) {
            return eval("".concat(item[sub.key], " ").concat(sub.type, " ").concat((sub.value / 100).toFixed(2)));
          });
        });
      }
      baseList.forEach(function (item) {
        sum.c06YDraft += item.c06YDraft + item.c06YAudit + item.c06YSend + item.c06YBack;
        sum.c06YSend += item.c06YSend + item.c06YBack;
        sum.c06YBack += item.c06YBack;
        sum.c06WDraft += item.c06WDraft + item.c06WAudit + item.c06WSend + item.c06WBack;
        sum.c06WSend += item.c06WSend + item.c06WBack;
        sum.c06WBack += item.c06WBack;
        sum.c06QDraft += item.c06QDraft + item.c06QAudit + item.c06QSend + item.c06QBack;
        sum.c06QSend += item.c06QSend + item.c06QBack;
        sum.c06QBack += item.c06QBack;
        sum.c06YBConclusion += item.c06YBConclusion;
        sum.c06YBStatus += item.c06YBStatus;
        sum.c06YBAddress += item.c06YBAddress;
        sum.c06WBConclusion += item.c06WBConclusion;
        sum.c06WBStatus += item.c06WBStatus;
        sum.c06WBAddress += item.c06WBAddress;
        sum.c06QBConclusion += item.c06QBConclusion;
        sum.c06QBStatus += item.c06QBStatus;
        sum.c06QBAddress += item.c06QBAddress;
        sum.c06WBack2 += item.c06YBack - item.c06YBEffective - item.c06YBInvalid;
        sum.c06WBEffective += item.c06YBEffective;
        sum.c06WBInvalid += item.c06YBInvalid;
        sum.c06YBack2 += item.c06WBack - item.c06WBEffective - item.c06WBInvalid;
        sum.c06YBEffective += item.c06WBEffective;
        sum.c06YBInvalid += item.c06WBInvalid;
        sum.c06QBack2 += item.c06QBack - item.c06QBEffective - item.c06QBInvalid;
        sum.c06QBEffective += item.c06QBEffective;
        sum.c06QBInvalid += item.c06QBInvalid;
      });
      return [].concat(_toConsumableArray(baseList), [sum]);
    },
    filterObj: function filterObj() {
      return {
        bank: {
          back: {
            value: this.filterForm.bank.back.value,
            type: this.filterForm.bank.back.type,
            key: 'yBackRatio'
          },
          jielun: {
            value: this.filterForm.bank.jielun.value,
            type: this.filterForm.bank.jielun.type,
            key: 'yBConclusionRatio'
          },
          yichang: {
            value: this.filterForm.bank.yichang.value,
            type: this.filterForm.bank.yichang.type,
            key: 'yBStatusRatio'
          },
          dizhi: {
            value: this.filterForm.bank.dizhi.value,
            type: this.filterForm.bank.dizhi.type,
            key: 'yBAddressRatio'
          },
          weigen: {
            value: this.filterForm.bank.weigen.value,
            type: this.filterForm.bank.weigen.type,
            key: 'yOfftrackRatio'
          },
          youxiao: {
            value: this.filterForm.bank.youxiao.value,
            type: this.filterForm.bank.youxiao.type,
            key: 'yBEffectiveRatio'
          },
          wuxiao: {
            value: this.filterForm.bank.wuxiao.value,
            type: this.filterForm.bank.wuxiao.type,
            key: 'yBInvalidRatio'
          }
        },
        w: {
          back: {
            value: this.filterForm.w.back.value,
            type: this.filterForm.w.back.type,
            key: 'wBackRatio'
          },
          jielun: {
            value: this.filterForm.w.jielun.value,
            type: this.filterForm.w.jielun.type,
            key: 'wBConclusionRatio'
          },
          yichang: {
            value: this.filterForm.w.yichang.value,
            type: this.filterForm.w.yichang.type,
            key: 'wBStatusRatio'
          },
          dizhi: {
            value: this.filterForm.w.dizhi.value,
            type: this.filterForm.w.dizhi.type,
            key: 'wBAddressRatio'
          },
          weigen: {
            value: this.filterForm.w.weigen.value,
            type: this.filterForm.w.weigen.type,
            key: 'wOfftrackRatio'
          },
          youxiao: {
            value: this.filterForm.w.youxiao.value,
            type: this.filterForm.w.youxiao.type,
            key: 'wBEffectiveRatio'
          },
          wuxiao: {
            value: this.filterForm.w.wuxiao.value,
            type: this.filterForm.w.wuxiao.type,
            key: 'wBInvalidRatio'
          }
        },
        q: {
          back: {
            value: this.filterForm.q.back.value,
            type: this.filterForm.q.back.type,
            key: 'qBackRatio'
          },
          jielun: {
            value: this.filterForm.q.jielun.value,
            type: this.filterForm.q.jielun.type,
            key: 'qBConclusionRatio'
          },
          yichang: {
            value: this.filterForm.q.yichang.value,
            type: this.filterForm.q.yichang.type,
            key: 'qBStatusRatio'
          },
          dizhi: {
            value: this.filterForm.q.dizhi.value,
            type: this.filterForm.q.dizhi.type,
            key: 'qBAddressRatio'
          },
          weigen: {
            value: this.filterForm.q.weigen.value,
            type: this.filterForm.q.weigen.type,
            key: 'qOfftrackRatio'
          },
          youxiao: {
            value: this.filterForm.q.youxiao.value,
            type: this.filterForm.q.youxiao.type,
            key: 'qBEffectiveRatio'
          },
          wuxiao: {
            value: this.filterForm.q.wuxiao.value,
            type: this.filterForm.q.wuxiao.type,
            key: 'qBInvalidRatio'
          }
        }
      };
    }
  }, mapState('cpscc', ['userInfo'])), {}, {
    isAdmin: function isAdmin() {
      var user = this.userInfo;
      if (user && user.data2) {
        return user.data2.admin;
      }
      return false;
    },
    isCpscAdmin: function isCpscAdmin() {
      if (this.userInfo && this.userInfo.data2) {
        if (Array.isArray(this.userInfo.data2.roles)) {
          return this.userInfo.data2.roles.includes('函证中心管理员');
        }
      }
      return false;
    }
  }),
  data: function data() {
    return {
      loading: false,
      activeName: 'echart',
      collapse: undefined,
      maxHeight: undefined,
      dataList: [],
      bankDataSum: 0,
      companyDataSum: 0,
      otherDataSum: 0,
      year: new Date(),
      tableDataList: [],
      loading2: false,
      test: '>',
      filterForm: {
        banktype: '>=',
        bank: {
          back: {
            value: undefined,
            type: '>='
          },
          jielun: {
            value: undefined,
            type: '>='
          },
          yichang: {
            value: undefined,
            type: '>='
          },
          dizhi: {
            value: undefined,
            type: '>='
          },
          weigen: {
            value: undefined,
            type: '>='
          },
          youxiao: {
            value: undefined,
            type: '>='
          },
          wuxiao: {
            value: undefined,
            type: '>='
          }
        },
        w: {
          back: {
            value: undefined,
            type: '>='
          },
          jielun: {
            value: undefined,
            type: '>='
          },
          yichang: {
            value: undefined,
            type: '>='
          },
          dizhi: {
            value: undefined,
            type: '>='
          },
          weigen: {
            value: undefined,
            type: '>='
          },
          youxiao: {
            value: undefined,
            type: '>='
          },
          wuxiao: {
            value: undefined,
            type: '>='
          }
        },
        q: {
          back: {
            value: undefined,
            type: '>='
          },
          jielun: {
            value: undefined,
            type: '>='
          },
          yichang: {
            value: undefined,
            type: '>='
          },
          dizhi: {
            value: undefined,
            type: '>='
          },
          weigen: {
            value: undefined,
            type: '>='
          },
          youxiao: {
            value: undefined,
            type: '>='
          },
          wuxiao: {
            value: undefined,
            type: '>='
          }
        }
      },
      filterTypeOptions: [{
        label: '大于',
        value: '>'
      }, {
        label: '大于等于',
        value: '>='
      }, {
        label: '等于',
        value: '==='
      }, {
        label: '小于',
        value: '<'
      }, {
        label: '小于等于',
        value: '<='
      }],
      filterArr: [],
      searching: false
    };
  },
  methods: {
    getData: function getData() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _yield$_this3$$awaitT, _yield$_this3$$awaitT2, err, data;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _this3.loading = true;
              _this3.dataList = [];
              _context.n = 1;
              return _this3.$awaitTo(getExtendedStats({
                flag: 0
                // groupBy: 'c06Year',
                // Sums: 'c06YBack,c06YDraft,c06YAudit,c06YSend'
              }));
            case 1:
              _yield$_this3$$awaitT = _context.v;
              _yield$_this3$$awaitT2 = _slicedToArray(_yield$_this3$$awaitT, 2);
              err = _yield$_this3$$awaitT2[0];
              data = _yield$_this3$$awaitT2[1];
              _this3.loading = false;
              if (!err) {
                _context.n = 2;
                break;
              }
              return _context.a(2);
            case 2:
              if (Array.isArray(data)) {
                _this3.dataList = data;
                _this3.update();
              }
            case 3:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    getTableDataList: function getTableDataList() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _yield$_this4$$awaitT, _yield$_this4$$awaitT2, err, data;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _this4.loading2 = true;
              _context2.n = 1;
              return _this4.$awaitTo(getTaskStaticalData({
                PageNumber: 1,
                PageSize: 10
              }));
            case 1:
              _yield$_this4$$awaitT = _context2.v;
              _yield$_this4$$awaitT2 = _slicedToArray(_yield$_this4$$awaitT, 2);
              err = _yield$_this4$$awaitT2[0];
              data = _yield$_this4$$awaitT2[1];
              _this4.loading2 = false;
              if (!err) {
                _context2.n = 2;
                break;
              }
              return _context2.a(2);
            case 2:
              console.log(data);
            case 3:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    initChart: function initChart() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        params: {}
      };
      var self = this;
      // 基于准备好的dom，初始化echarts实例
      var myChart = echarts.init(this.$refs[options.id], 'macarons');
      // 绘制图表
      myChart.setOption(_objectSpread({
        tooltip: {
          trigger: 'item',
          formatter: '{b}: {c} ({d}%)'
        },
        series: [{
          name: '',
          type: 'pie',
          avoidLabelOverlap: true,
          center: ['50%', '140'],
          radius: [10, 65],
          label: {
            formatter: function formatter(params) {
              return "".concat(params.name, " \n ").concat(params.value, "(").concat(params.percent, "%)");
            }
          },
          data: options.data
        }],
        legend: {
          type: 'scroll',
          top: 0,
          icon: 'circle',
          formatter: function formatter(name) {
            // let total = 0
            // let tarValue
            // for (let i = 0, l = options.data.length; i < l; i++) {
            //   total += options.data[i].value
            //   if (options.data[i].name === name) {
            //     tarValue = options.data[i].value
            //   }
            // }
            // const p = (tarValue / total * 100).toFixed(0)
            return "";
          },
          textStyle: {
            color: []
          }
        }
      }, options.params));
      myChart.on('click', function (data) {
        if (data.data.link) {
          // self.$router.push(data.data.link)
        }
      });
      // this.chartList.push(myChart)
    },
    initBarChart: function initBarChart() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        params: {}
      };
      var myChart = echarts.init(this.$refs[options.id], 'macarons');
      var self = this;
      myChart.setOption(_objectSpread({
        legend: {
          type: 'scroll',
          icon: 'circle'
        },
        tooltip: {
          trigger: 'axis'
        },
        yAxis: {
          type: 'value',
          max: function max(val) {
            return val.max + 50;
          }
        },
        grid: {
          left: '10',
          right: '10',
          bottom: '10',
          top: '30',
          containLabel: true
        },
        series: [{
          data: options.data,
          type: 'bar'
        }]
      }, options.params));
    },
    initBankData: function initBankData() {
      var draft = this.list.reduce(function (a, b) {
        return a + b.c06YDraft;
      }, 0);
      var audit = this.list.reduce(function (a, b) {
        return a + b.c06YAudit;
      }, 0);
      var send = this.list.reduce(function (a, b) {
        return a + b.c06YSend;
      }, 0);
      var back = this.list.reduce(function (a, b) {
        return a + b.c06YBack;
      }, 0);
      var cancel = this.list.reduce(function (a, b) {
        return a + b.c06YNullify;
      }, 0);
      this.bankDataSum = draft + audit + send + back + cancel;
      this.initChart({
        id: 'bank',
        title: '函证状态数据统计',
        data: [{
          name: '草稿',
          value: draft
        }, {
          name: '已审',
          value: audit
        }, {
          name: '已发',
          value: send
        }, {
          name: '已回',
          value: back
        }, {
          name: '作废',
          value: cancel
        }]
      });
    },
    initBankBackData: function initBankBackData() {
      var back = this.list.reduce(function (a, b) {
        return a + b.c06YBack;
      }, 0);
      var inconformity = this.list.reduce(function (a, b) {
        return a + b.c06YBConclusion;
      }, 0);
      var abnormal = this.list.reduce(function (a, b) {
        return a + b.c06YBStatus;
      }, 0);
      var address = this.list.reduce(function (a, b) {
        return a + b.c06YBAddress;
      }, 0);
      this.initBarChart({
        id: 'bankBack',
        params: {
          xAxis: {
            type: 'category',
            data: ['回函数量', '函证不符数量', '函证异常', '地址异常']
          }
        },
        data: [{
          value: back,
          itemStyle: {
            color: echartTheme.color[0]
          },
          label: {
            show: true,
            position: 'top'
          }
        }, {
          value: inconformity,
          itemStyle: {
            color: echartTheme.color[1]
          },
          label: {
            show: true,
            position: 'top',
            formatter: function formatter(params) {
              return "".concat(params.value, " \n (").concat((params.value / back * 100).toFixed(2), "%)");
            }
          }
        }, {
          value: abnormal,
          itemStyle: {
            color: echartTheme.color[2]
          },
          label: {
            show: true,
            position: 'top',
            formatter: function formatter(params) {
              return "".concat(params.value, " \n (").concat((params.value / back * 100).toFixed(2), "%)");
            }
          }
        }, {
          value: address,
          itemStyle: {
            color: echartTheme.color[3]
          },
          label: {
            show: true,
            position: 'top',
            formatter: function formatter(params) {
              return "".concat(params.value, " \n (").concat((params.value / back * 100).toFixed(2), "%)");
            }
          }
        }]
      });
    },
    initBankTrackData: function initBankTrackData() {
      var back = this.list.reduce(function (a, b) {
        return a + b.c06YBack;
      }, 0);
      var resolve = this.list.reduce(function (a, b) {
        return a + b.c06YBEffective;
      }, 0);
      var cancel = this.list.reduce(function (a, b) {
        return a + b.c06YBInvalid;
      }, 0);
      this.initChart({
        id: 'bankTrack',
        title: '函证状态数据统计',
        data: [{
          name: '未确认',
          value: back - resolve - cancel
        }, {
          name: '有效',
          value: resolve
        }, {
          name: '无效',
          value: cancel
        }]
      });
    },
    initCompanyData: function initCompanyData() {
      var draft = this.list.reduce(function (a, b) {
        return a + b.c06WDraft;
      }, 0);
      var audit = this.list.reduce(function (a, b) {
        return a + b.c06WAudit;
      }, 0);
      var send = this.list.reduce(function (a, b) {
        return a + b.c06WSend;
      }, 0);
      var back = this.list.reduce(function (a, b) {
        return a + b.c06WBack;
      }, 0);
      var cancel = this.list.reduce(function (a, b) {
        return a + b.c06WNullify;
      }, 0);
      this.companyDataSum = draft + audit + send + back + cancel;
      this.initChart({
        id: 'company',
        title: '函证状态数据统计',
        data: [{
          name: '草稿',
          value: draft
        }, {
          name: '已审',
          value: audit
        }, {
          name: '已发',
          value: send
        }, {
          name: '已回',
          value: back
        }, {
          name: '作废',
          value: cancel
        }]
      });
    },
    initCompanyBackData: function initCompanyBackData() {
      var back = this.list.reduce(function (a, b) {
        return a + b.c06WBack;
      }, 0);
      var inconformity = this.list.reduce(function (a, b) {
        return a + b.c06WBConclusion;
      }, 0);
      var abnormal = this.list.reduce(function (a, b) {
        return a + b.c06WBStatus;
      }, 0);
      var address = this.list.reduce(function (a, b) {
        return a + b.c06WBAddress;
      }, 0);
      this.initBarChart({
        id: 'companyBack',
        params: {
          xAxis: {
            type: 'category',
            data: ['回函数量', '函证不符数量', '函证异常', '地址异常']
          }
        },
        data: [{
          value: back,
          itemStyle: {
            color: echartTheme.color[0]
          },
          label: {
            position: 'top',
            show: true
          }
        }, {
          value: inconformity,
          itemStyle: {
            color: echartTheme.color[1]
          },
          label: {
            show: true,
            position: 'top',
            formatter: function formatter(params) {
              return "".concat(params.value, " \n (").concat((params.value / back * 100).toFixed(2), "%)");
            }
          }
        }, {
          value: abnormal,
          itemStyle: {
            color: echartTheme.color[2]
          },
          label: {
            show: true,
            position: 'top',
            formatter: function formatter(params) {
              return "".concat(params.value, " \n (").concat((params.value / back * 100).toFixed(2), "%)");
            }
          }
        }, {
          value: address,
          itemStyle: {
            color: echartTheme.color[3]
          },
          label: {
            show: true,
            position: 'top',
            formatter: function formatter(params) {
              return "".concat(params.value, " \n (").concat((params.value / back * 100).toFixed(2), "%)");
            }
          }
        }]
      });
    },
    initCompanyTrackData: function initCompanyTrackData() {
      var back = this.list.reduce(function (a, b) {
        return a + b.c06WBack;
      }, 0);
      var resolve = this.list.reduce(function (a, b) {
        return a + b.c06WBEffective;
      }, 0);
      var cancel = this.list.reduce(function (a, b) {
        return a + b.c06WBInvalid;
      }, 0);
      this.initChart({
        id: 'companyTrack',
        title: '函证状态数据统计',
        data: [{
          name: '未确认',
          value: back - resolve - cancel
        }, {
          name: '有效',
          value: resolve
        }, {
          name: '无效',
          value: cancel
        }]
      });
    },
    initOtherData: function initOtherData() {
      var draft = this.list.reduce(function (a, b) {
        return a + b.c06QDraft;
      }, 0);
      var audit = this.list.reduce(function (a, b) {
        return a + b.c06QAudit;
      }, 0);
      var send = this.list.reduce(function (a, b) {
        return a + b.c06QSend;
      }, 0);
      var back = this.list.reduce(function (a, b) {
        return a + b.c06QBack;
      }, 0);
      var cancel = this.list.reduce(function (a, b) {
        return a + b.c06QNullify;
      }, 0);
      this.otherDataSum = draft + audit + send + back + cancel;
      this.initChart({
        id: 'other',
        title: '函证状态数据统计',
        data: [{
          name: '草稿',
          value: draft
        }, {
          name: '已审',
          value: audit
        }, {
          name: '已发',
          value: send
        }, {
          name: '已回',
          value: back
        }, {
          name: '作废',
          value: cancel
        }]
      });
    },
    initOtherBackData: function initOtherBackData() {
      var back = this.list.reduce(function (a, b) {
        return a + b.c06QBack;
      }, 0);
      var inconformity = this.list.reduce(function (a, b) {
        return a + b.c06QBConclusion;
      }, 0);
      var abnormal = this.list.reduce(function (a, b) {
        return a + b.c06QBStatus;
      }, 0);
      var address = this.list.reduce(function (a, b) {
        return a + b.c06QBAddress;
      }, 0);
      this.initBarChart({
        id: 'otherBack',
        params: {
          xAxis: {
            type: 'category',
            data: ['回函数量', '函证不符数量', '函证异常', '地址异常']
          }
        },
        data: [{
          value: back,
          itemStyle: {
            color: echartTheme.color[0]
          },
          label: {
            show: true,
            position: 'top'
          }
        }, {
          value: inconformity,
          itemStyle: {
            color: echartTheme.color[1]
          },
          label: {
            show: true,
            position: 'top',
            formatter: function formatter(params) {
              return "".concat(params.value, " \n (").concat((params.value / back * 100).toFixed(2), "%)");
            }
          }
        }, {
          value: abnormal,
          itemStyle: {
            color: echartTheme.color[2]
          },
          label: {
            show: true,
            position: 'top',
            formatter: function formatter(params) {
              return "".concat(params.value, " \n (").concat((params.value / back * 100).toFixed(2), "%)");
            }
          }
        }, {
          value: address,
          itemStyle: {
            color: echartTheme.color[3]
          },
          label: {
            show: true,
            position: 'top',
            formatter: function formatter(params) {
              return "".concat(params.value, " \n (").concat((params.value / back * 100).toFixed(2), "%)");
            }
          }
        }]
      });
    },
    initOtherTrackData: function initOtherTrackData() {
      var back = this.list.reduce(function (a, b) {
        return a + b.c06QBack;
      }, 0);
      var resolve = this.list.reduce(function (a, b) {
        return a + b.c06QBEffective;
      }, 0);
      var cancel = this.list.reduce(function (a, b) {
        return a + b.c06QBInvalid;
      }, 0);
      this.initChart({
        id: 'otherTrack',
        title: '函证状态数据统计',
        data: [{
          name: '未确认',
          value: back - resolve - cancel
        }, {
          name: '有效',
          value: resolve
        }, {
          name: '无效',
          value: cancel
        }]
      });
    },
    update: function update() {
      this.initBankData();
      this.initBankBackData();
      this.initBankTrackData();
      this.initCompanyData();
      this.initCompanyBackData();
      this.initCompanyTrackData();
      this.initOtherData();
      this.initOtherBackData();
      this.initOtherTrackData();
    },
    headerCellClassName: function headerCellClassName(_ref) {
      var row = _ref.row,
        column = _ref.column,
        rowIndex = _ref.rowIndex,
        columnIndex = _ref.columnIndex;
      if (['s', 's-1', 's-1-1', 's-1-2', 's-1-3', 's-2', 's-2', 's-2-1', 's-2-2', 's-2-3', 's-3', 's-3-1', 's-3-2', 's-3-3'].includes(column.property)) {
        return 'app-theme-table-header-color1';
      } else if (['a', 'a-1', 'a-1-1', 'a-1-2', 'a-1-3', 'a-2', 'a-2', 'a-2-1', 'a-2-2', 'a-2-3', 'a-3', 'a-3-1', 'a-3-2', 'a-3-3'].includes(column.property)) {
        return 'app-theme-table-header-color2';
      } else if (['g', 'g-1', 'g-1-1', 'g-1-2', 'g-1-3', 'g-2', 'g-2', 'g-2-1', 'g-2-2', 'g-2-3', 'g-3', 'g-3-1', 'g-3-2', 'g-3-3'].includes(column.property)) {
        return 'app-theme-table-header-color3';
      }
    },
    rowClassName: function rowClassName(_ref2) {
      var row = _ref2.row,
        rowIndex = _ref2.rowIndex;
      if (rowIndex === this.tableData.length - 1) {
        return 'app-theme-table-header-color4';
      }
      return '';
    },
    cellClassName: function cellClassName(_ref3) {
      var row = _ref3.row,
        column = _ref3.column,
        rowIndex = _ref3.rowIndex,
        columnIndex = _ref3.columnIndex;
      if (['s', 's-1', 's-1-1', 's-1-2', 's-1-3', 's-2', 's-2', 's-2-1', 's-2-2', 's-2-3', 's-3', 's-3-1', 's-3-2', 's-3-3'].includes(column.property)) {
        return 'app-theme-table-cell-color1';
      } else if (['a', 'a-1', 'a-1-1', 'a-1-2', 'a-1-3', 'a-2', 'a-2', 'a-2-1', 'a-2-2', 'a-2-3', 'a-3', 'a-3-1', 'a-3-2', 'a-3-3'].includes(column.property)) {
        return 'app-theme-table-cell-color2';
      } else if (['g', 'g-1', 'g-1-1', 'g-1-2', 'g-1-3', 'g-2', 'g-2', 'g-2-1', 'g-2-2', 'g-2-3', 'g-3', 'g-3-1', 'g-3-2', 'g-3-3'].includes(column.property)) {
        return 'app-theme-table-cell-color3';
      }
    },
    submit: function submit() {
      var _this5 = this;
      if (this.searching) {
        return;
      }
      this.searching = true;
      this.filterArr = [];
      var values = Object.values(this.filterObj);
      var list = [];
      for (var i = 0; i < values.length; i++) {
        var v = Object.values(values[i]);
        var res = v.filter(function (item) {
          console.log(item);
          return item.value !== '' && item.value !== undefined;
        });
        list.push.apply(list, _toConsumableArray(res));
      }
      this.filterArr = list;
      this.$nextTick(function () {
        _this5.searching = false;
      });
    }
  },
  mounted: function mounted() {
    var _this6 = this;
    this.$nextTick(function () {
      _this6.getData();
      echarts.registerTheme('macarons', echartTheme);
    });
    // this.getTableDataList()

    // setTimeout(() => {
    //
    // }, 1000)
    var body = this.$refs.page;
    this.maxHeight = body.$el.clientHeight * 0.75;
  },
  filters: {
    ratio: function ratio(val) {
      if (val !== undefined && val !== '') {
        if (val === 1) {
          return "".concat(val * 100, "%");
        }
        return "".concat((val * 100).toFixed(2), "%");
      }
      return 0;
    }
  }
};